<template>
  <!--图文配置 默认样式-->
  <div class="default-banner">
    <p>{{ text }}</p>
    <i v-if="!status" class="iconfont icon-logo1" :style="{ fontSize }"></i>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "配置文字图片",
    },
    fontSize: {
      type: String,
      default: "88px",
    },
    status: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.default-banner {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  position: relative;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  background-position: center;
  background-size: 100% 100%;
  p {
    position: absolute;
    left: 30px;
    bottom: 30px;
  }
  .icon-logo1 {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
    opacity: 0.1974;
  }
}
</style>
